import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import { useDispatch } from "react-redux";
import { EMenuActions } from "../../store";
import WaiterCall from "./waiterCall";

const Waiter = () => {
	let dispatch = useDispatch();

	const handleCloseReview = () => {
		dispatch(EMenuActions.setWaiterCall(false));
	};
	const handleNoPropagate = (e) => {
		e.stopPropagation();
	};

	return (
		<div onClick={handleCloseReview} className="fixed w-[100%] h-[100vh] top-0 py-12 lg:py-12 px-5 lg:px-24 z-10 bg-dark/70">
			<div onClick={handleNoPropagate}>
				<div className=" py-3 m-auto mt-5 rounded-t-sm items-center bg-secondary flex justify-between px-4 sm:w-[100%] md:w-[50%] lg:w-[30%]">
					<h1 className="text-white font-bold flex justify-center">Call a waiter</h1>
					<div onClick={handleCloseReview} className="cursor-pointer">
						<FontAwesomeIcon icon={faTimes} size="2xl" className="text-black" />
					</div>
				</div>
				<WaiterCall />
			</div>
		</div>
	);
};
export default Waiter;
